/**
 * Copyright © 2025 Indisea Software LLC. All rights reserved.
 *
 * Proprietary and confidential. Licensed, not sold. Use is subject to the
 * license agreement between Indisea Software LLC and the licensee.
 * See LICENSE for full terms.
 *
 * SPDX-License-Identifier: LicenseRef-Indisea-Proprietary
 */


import React from 'react';
import { Route, Routes } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import CustomersListPage from './pages/CustomersListPage';
import LogsPage from './pages/LogsPage';
import { AuthProvider } from './context/AuthContext';
import { LoaderProvider } from './context/LoaderContext';
import MainLayout from './MainLayout';


function App() {
  return (
    <AuthProvider>
      <LoaderProvider>
        <MainLayout>
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/customers" element={<CustomersListPage />} />
            <Route path="/logs" element={<LogsPage />} />
          </Routes>
        </MainLayout>
      </LoaderProvider>
    </AuthProvider>
  );
}

export default App;
